import { types } from 'mobx-state-tree';
import { getHTTPClient } from 'src/core/services/api/httpClient';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { IS_PAYMENT_METHOD } from 'src/constants/payments';
import { HS_USER_KEYS, USER_SETTINGS_KEYS } from 'src/constants/userSetting';
const tokensInitialData = {
  accessToken: '',
  refreshToken: '',
  expiresOn: '',
  requireMfa: false,
  session: ''
};
const tokens = types.model('tokens', {
  accessToken: types.string,
  refreshToken: types.string,
  expiresOn: types.string,
  requireMfa: types.boolean,
  session: types.string
});
const initializeAccessToken = (token, apiSource) => {
  getHTTPClient(apiSource).defaults.headers.common[
  // eslint-disable-next-line @typescript-eslint/dot-notation
  'Authorization'] = "Bearer ".concat(token);
};
const AuthStore = types.model('AuthStore', {
  tokens: types.optional(tokens, tokensInitialData)
}).actions(store => ({
  setTokens(data) {
    Object.keys(data).forEach(key => {
      store[key] = data[key];
    });
    initializeAccessToken(data.accessToken);
    initializeAccessToken(data.accessToken, 'activity');
    initializeAccessToken(data.accessToken, 'allocations');
    initializeAccessToken(data.accessToken, 'auth');
    initializeAccessToken(data.accessToken, 'file');
    initializeAccessToken(data.accessToken, 'payment');
    initializeAccessToken(data.accessToken, 'property');
    initializeAccessToken(data.accessToken, 'paperCorrespondence');
    initializeAccessToken(data.accessToken, 'aggregate');
    initializeAccessToken(data.accessToken, 'appfolio');
    initializeAccessToken(data.accessToken, 'stripe');
    initializeAccessToken(data.accessToken, 'billAutomation');
  },
  setTokensAfterRefresh(data) {
    store.tokens.accessToken = data.accessToken;
    store.tokens.expiresOn = data.expiresOn;
    initializeAccessToken(data.accessToken);
    initializeAccessToken(data.accessToken, 'activity');
    initializeAccessToken(data.accessToken, 'allocations');
    initializeAccessToken(data.accessToken, 'auth');
    initializeAccessToken(data.accessToken, 'file');
    initializeAccessToken(data.accessToken, 'payment');
    initializeAccessToken(data.accessToken, 'property');
    initializeAccessToken(data.accessToken, 'paperCorrespondence');
    initializeAccessToken(data.accessToken, 'aggregate');
    initializeAccessToken(data.accessToken, 'appfolio');
    initializeAccessToken(data.accessToken, 'stripe');
    initializeAccessToken(data.accessToken, 'billAutomation');
  },
  reset() {
    localStorage.removeItem(AUTH_TOKEN_KEYS.accessToken);
    localStorage.removeItem(AUTH_TOKEN_KEYS.expiresOn);
    localStorage.removeItem(AUTH_TOKEN_KEYS.refreshToken);
    localStorage.removeItem(AUTH_TOKEN_KEYS.requireMfa);
    localStorage.removeItem(AUTH_TOKEN_KEYS.session);
    localStorage.removeItem(AUTH_TOKEN_KEYS.demoPropertyMode);
    localStorage.removeItem(USER_SETTINGS_KEYS.company);
    localStorage.removeItem(USER_SETTINGS_KEYS.confirmation);
    localStorage.removeItem(USER_SETTINGS_KEYS.emailConfirmed);
    localStorage.removeItem(USER_SETTINGS_KEYS.phoneConfirmed);
    localStorage.removeItem(USER_SETTINGS_KEYS.userRole);
    localStorage.removeItem(USER_SETTINGS_KEYS.companyName);
    localStorage.removeItem(HS_USER_KEYS.email);
    localStorage.removeItem(HS_USER_KEYS.token);
    localStorage.removeItem(IS_PAYMENT_METHOD);
    localStorage.removeItem('livable_portfolio_id');
    localStorage.removeItem('livable_property_id');
    this.setTokens(tokensInitialData);
  },
  checkAuth() {
    const accessToken = localStorage.getItem(AUTH_TOKEN_KEYS.accessToken);
    if (!!accessToken) {
      initializeAccessToken(accessToken);
      initializeAccessToken(accessToken, 'activity');
      initializeAccessToken(accessToken, 'allocations');
      initializeAccessToken(accessToken, 'auth');
      initializeAccessToken(accessToken, 'file');
      initializeAccessToken(accessToken, 'payment');
      initializeAccessToken(accessToken, 'property');
      initializeAccessToken(accessToken, 'paperCorrespondence');
      initializeAccessToken(accessToken, 'aggregate');
      initializeAccessToken(accessToken, 'appfolio');
      initializeAccessToken(accessToken, 'stripe');
      initializeAccessToken(accessToken, 'billAutomation');
    }
  }
}));
export const auth = types.optional(AuthStore, {});